import { render, staticRenderFns } from "./ToolbarEditor.vue?vue&type=template&id=4db21020&"
import script from "./ToolbarEditor.vue?vue&type=script&lang=js&"
export * from "./ToolbarEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports